import * as React from "react"

const Minus = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M4.5 7h7v1h-7V7Z" />
  </svg>
)

export default Minus
